import { combineReducers } from 'redux';

import auth from './_auth/reducers'
import notify from './_notify/reducers/index';
import {
    companyReducer,
    fixturesReducer,
    offerSelectedReducer,
    offersReducer,
    candidateReducer,
    companyOffersEmulationReducer,
    companyOffersCountReducer,
    companyCandidatesCountReducer,
    companyOffersFilterReducer,
    companyOffersApplicationFilterReducer
} from "./jobs/reducers";



export default combineReducers({
    notify,
    auth,
    companyOffersEmulation: companyOffersEmulationReducer,
    company: companyReducer,
    offers: offersReducer,
    companyOffersCount: companyOffersCountReducer,
    companyCandidatesCount: companyCandidatesCountReducer,
    companyOffersFilter: companyOffersFilterReducer,
    companyOffersApplicationFilter: companyOffersApplicationFilterReducer,
    fixtures: fixturesReducer,
    offerReducer: offerSelectedReducer,
    candidateReducer: candidateReducer
});
